export default __webpack_public_path__ + "static/media/wordmark.6e5993a5.svg";